import React from 'react';
import './UploaderBackground.css';

interface UploaderBackgroundProps {
  children?: React.ReactNode;
  className?: string;
}

const UploaderBackground: React.FC<UploaderBackgroundProps> = React.memo(({ children, className = '' }) => {
  return (
    <div className={`relative w-full h-full overflow-hidden bg-black ${className}`}>
      {/* Background Container */}
      <div className="uploader-background-container">
        <div className="scene-stage" aria-hidden="true">
          <div className="luminescent-arc"></div>
        </div>
      </div>

      {/* Content */}
      <div className="uploader-content-wrapper">
        {children}
      </div>
    </div>
  );
});

UploaderBackground.displayName = 'UploaderBackground';

export default UploaderBackground;
